import styled from "styled-components";

export const TableLoadingStyled = styled.div<{ height: number }>`
    width: 100%;
    height: ${props => props.height}px;
    display:flex;
    align-items:center;
    justify-content:center;
`